import { render, staticRenderFns } from "./ReqAffiliationModal.vue?vue&type=template&id=2d6f54a8&"
import script from "./ReqAffiliationModal.vue?vue&type=script&lang=js&"
export * from "./ReqAffiliationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports